import { styled } from '@mui/material';

export const Placeholder = styled('span')`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.primary.p040};
  @media (max-width: 1023px) {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
  }
`;

export const MultipleSelectWrap = styled('div')`
  display: flex;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;
  width: 100%;
`;
